import axios from 'axios';

export interface ICanLinkAccounts {
  currentEmail: string;
  targetEmail: string;
}

export const canLinkAccounts = async ({
  currentEmail,
  targetEmail,
}: ICanLinkAccounts) =>
  axios.get('user/link', { params: { currentEmail, targetEmail } });
